export enum FormState {
  VALID = 'VALID',
  INVALID = 'INVALID',
  PENDING = 'PENDING'
}
